import { Component, Input, OnInit, ChangeDetectorRef } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { DealsType01Component } from "../../deals/deals-type01/deals-type01.component";
import { Router, RouterLink } from '@angular/router';

import { TFMService } from 'app/mock-api/tfm.service';
import { CountersType01Component } from '../../counter/counters-type01/counters-type01.component';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-xl-leisure-travel-type03',
    standalone: true,
    imports: [DealsType01Component, RouterLink, CountersType01Component, NgClass],
    templateUrl: './xl-leisure-travel-type03.component.html',
    styleUrls: ['./xl-leisure-travel-type03.component.css'],
})
export class XlLeisureTravelComponentType03 implements OnInit {

    @Input() isLandingPage:boolean = false;
    @Input() content:string;

    public view: any = {};

    constructor(public _tfmService: TFMService, private router: Router, private metaService: Meta, private title: Title, private _cd: ChangeDetectorRef) {
        this._tfmService.getDestinations().then((res) => {
            this.view.destinations = res;
            // console.log(this.view.destinations);
        });
    }

    startSlideshow(): void {
    setInterval(() => {
      const nextIndex = (this.view.currentImageIndex + 1) % this.view.imageHrefs.length;
      const nextImage = this.view.imageHrefs[nextIndex];

      this.fadeToImage(nextImage);
      this.view.currentImageIndex = nextIndex;
    }, 5000);
  }

  fadeToImage(nextImage: string): void {
    const img = new Image();
    img.src = nextImage;

    img.onload = () => {
      if (this.view.activeLayer === 1) {
        this.view.imageLayer2 = nextImage;
        this.view.activeLayer = 2;
      } else {
        this.view.imageLayer1 = nextImage;
        this.view.activeLayer = 1;
      }
      this._cd.detectChanges();
    };
  }

    ngOnInit() {
        this._tfmService.getSite().then(res => {
      this.view.site = res;

      this.view.site.profile = this._tfmService.getSiteProfile(this.view.site.profileID);
      this._tfmService.log("Leisure Site", this.view.site);
    });

    this.view.currentImageIndex = 0;
    this.view.activeLayer = 1;
    this.view.imageLayer1 = ''; // start blank or with a default image
    this.view.imageLayer2 = '';

    this._tfmService.getContentBySection('leisure-travel').then((res) => {
      this.view.page = res;
      const images = this.view.page?.content?.images;
      this._tfmService.log("Leisure Page:", this.view.page);

      if (images && images.length > 0) {
        this.view.imageHrefs = images
          .map((img: any) => {
            const viewLink = img._links?.find((link: any) => link.rel === 'view');
            return viewLink?.href ?? null;
          })
          .filter((href: string | null) => href !== null);

        this.view.imageLayer1 = this.view.imageHrefs[0];
        this.startSlideshow();
      }
    });
    }

}
